(function () {
  "use strict";

  // ----------------------------
  // DOM Ready
  // ----------------------------
  $(function () {
    const $jsonEl = $("#ProductCartItems");
    if ($jsonEl.length < 1) return;

    let cartItems;
    try {
      cartItems = JSON.parse($jsonEl.html());
    } catch (e) {
      console.error("Invalid cart JSON in #ProductCartItems", e);
      return;
    }

    cartSort.init(cartItems);
  });

  // ----------------------------
  // Cart Sort (groups variants)
  // ----------------------------
  var cartSort = (window.cartSort = {
    cartItems: null,
    cartItemsClone: [],
    sortedCartItems: [],
    sortedCartItemsIndex: 0,

    init: function (cartItems) {
      this.cartItems = cartItems;
      this.cartItemsClone = JSON.parse(JSON.stringify((cartItems && cartItems.items) || []));
      this.sortedCartItems = [];
      this.sortedCartItemsIndex = 0;

      this.groupItems(this.cartItemsClone);

      if (this.sortedCartItems.length > 0) {
        CreateCartItem.init();
      } else {
        CreateCartItem.empty();
      }

      console.log("Sorted:", this.sortedCartItems);
      $(".cart-title-total-number").html(this.sortedCartItems.length);
    },

    groupItems: function (items) {
      if (!window.helper || typeof window.helper._groupVariants !== "function") {
        console.warn("window.helper._groupVariants not found");
        this.sortedCartItems = items || [];
        return this.sortedCartItems;
      }

      this.sortedCartItems = window.helper._groupVariants(items || []);
      return this.sortedCartItems;
    },
  });

  // ----------------------------
  // CreateCartItem (renders cart + sidebar)
  // ----------------------------
  var CreateCartItem = (window.CreateCartItem = {
    selectors: {
      cartWrapper: ".custom-cart-items",
      sidebarWrapper: ".sidebar-cart-items-wrapper",
      loading: ".loading-spinner-wrapper",

      cartItemTemplate: "#custom_cart_item_dom",
      qtyTemplate: "#custom_cart_item_qty_dom",
      sidebarItemTemplate: "#sidebar_cart_item_dom",

      cartCountBubble: ".cart-count-bubble",
      cartIcon: ".header__icon--cart",
      subtotalEls: ".totals__subtotal-value > span, .cart-subtotal__price",
    },

    // Cache for /variants/{id}.js calls
    _variantCache: {},

    init: function () {
      if (window.location.pathname === "/cart") {
        this.createCartItems();
      }
      this.createSideBarCartItems();
    },

    // ----------------------------
    // Render main cart items
    // ----------------------------
    createCartItems: function () {
      var self = this;
      var $wrapper = $(self.selectors.cartWrapper);
      $wrapper.html("");

      var items = (window.cartSort && window.cartSort.sortedCartItems) || [];
      if (!items.length) return;

      for (var i = items.length - 1; i >= 0; i--) {
        (function renderItem(cartItem) {
          var $itemDom = $(self.selectors.cartItemTemplate).clone();
          $itemDom.removeAttr("id").show();

          // Basic product info
          $itemDom.find(".custom-cart-item__product").attr("href", cartItem.url || "#");
          $itemDom.find(".custom-cart-item__title").html(cartItem.product_title || "");
          $itemDom.find(".custom-cart-item__image").attr(
            "src",
            cartItem.featured_image && cartItem.featured_image.url ? cartItem.featured_image.url : ""
          );

          // Price logic
          if (Number(cartItem.compare_at_price) !== 0 && cartItem.variants.length <= 2) {
            $itemDom.find(".custom-cart-item__final-price-wrapper").hide();
            $itemDom
              .find(".custom-cart-item__final-price > span")
              .html(window.helper._convertMoney(cartItem.compare_at_price));
            $itemDom
              .find(".custom-cart-item__final-sale-price > span")
              .html(window.helper._convertMoney(cartItem.final_line_price));
          } else {
            $itemDom.find(".custom-cart-item__final-sale-price-wrapper").hide();
            $itemDom.find(".custom-cart-item__final-price").html(window.helper._convertMoney(cartItem.final_line_price));
          }

          // Subscription text
          if (cartItem.variants && cartItem.variants[0] && cartItem.variants[0].selling_plan_allocation) {
            $itemDom
              .find(".custom-cart-item__subscription-text")
              .html(cartItem.variants[0].selling_plan_allocation.selling_plan.name);
          } else {
            $itemDom.find(".custom-cart-item__subscription-text").hide();
          }

          // Remove (removes all variants in group)
          $itemDom
            .find(".custom-cart-item__remove")
            .off("click.cart")
            .on("click.cart", function (e) {
              e.preventDefault();
              self.removeCartItemGroup($itemDom, cartItem);
            });

          // Sunglasses (only checks first variant as you had)
          if (
            cartItem.variants &&
            cartItem.variants[0] &&
            cartItem.variants[0].properties &&
            cartItem.variants[0].properties["Sunglasses"] !== undefined
          ) {
            $itemDom.find(".custom-cart-item__sunglasses-details-wrapper").show();
            $itemDom.find(".custom-cart-item__sunglasses-details").html(cartItem.variants[0].properties["Sunglasses"]);
            $itemDom.find(".custom-cart-item__sunglasses-img").attr("src", cartItem.variants[0].properties["sunglasses_image"]);
          } else {
            $itemDom.find(".custom-cart-item__sunglasses-details-wrapper").hide();
          }

          // Prescription popup
          if (
            cartItem.variants &&
            cartItem.variants[0] &&
            cartItem.variants[0].properties &&
            cartItem.variants[0].properties["Eye"] !== undefined
          ) {
            $itemDom
              .find(".custom-cart-item__prescription-details-wrapper > a")
              .off("click.cart")
              .on("click.cart", function (e) {
                e.preventDefault();
                self.showPrescriptionDetails(cartItem.variants);
              });
          }
          else if (
            cartItem.variants &&
            cartItem.variants[0] &&
            cartItem.variants[0].properties &&
            cartItem.variants[0].properties["glasses_prescription"] !== undefined
          ) {
            $itemDom
              .find(".custom-cart-item__prescription-details-wrapper > a")
              .off("click.cart")
              .on("click.cart", function (e) {
                e.preventDefault();
                self.showGlassesPrescriptionDetails(cartItem.variants);
              });
          }
          else {
            $itemDom.find(".custom-cart-item__prescription-details-wrapper").hide();
          }

          console.log(cartItem.variants[0].properties)

          // Quantity rendering
          self.renderQuantityControls($itemDom, cartItem);

          // Append
          $itemDom.appendTo($wrapper);
        })(items[i]);
      }
    },

    isGlassesPrescriptionBundle: function (cartItem) {
      var variants = (cartItem && cartItem.variants) || [];

      return variants.some(function (variant) {
        return (
          variant &&
          variant.properties &&
          variant.properties["glasses_prescription"] !== undefined
        );
      });
    },

    // ----------------------------
    // Quantity Controls
    // If variants > 2 => one group qty (atomic update)
    // Else => per variant qty
    // ----------------------------
    renderQuantityControls: function ($itemDom, cartItem) {
      var self = this;
      var $qtyWrapper = $itemDom.find(".custom-cart-item__variant-qty");
      $qtyWrapper.html("");

      var variants = (cartItem && cartItem.variants) || [];
      if (!variants.length) return;

       // Hide quantity area completely for glasses prescription bundled products
      if (self.isGlassesPrescriptionBundle(cartItem)) {
        $itemDom.addClass("custom-cart-item--glasses-prescription");
        $qtyWrapper.hide();
        return;
      }

      var groupQtyMode = variants.length > 2;

      // If ANY variant is sunglasses item, keep your behavior: hide qty UI
      var hasSunglassesVariant = variants.some(function (v) {
        return v && v.properties && v.properties["Sunglasses"] !== undefined;
      });

      if (hasSunglassesVariant) {
        $qtyWrapper.hide();
        return;
      } else {
        $qtyWrapper.show();
      }

      if (groupQtyMode) {
        // One control that updates all variants
        var $groupQtyDom = $(self.selectors.qtyTemplate).clone();
        $groupQtyDom.removeAttr("id").show();

        var groupSize = variants.length;

        var totalQty = variants.reduce(function (sum, v) {
          return sum + (Number(v.quantity) || 0);
        }, 0);

        // Display "bundle quantity" instead of total units.
        // If quantities are consistent across variants, bundleQty will be clean.
        // If not, fall back to showing the rounded-down value (or you can show "-").
        var bundleQty = Math.floor(totalQty / groupSize);

        // Optional: if you want to be strict and only show bundle qty when all variant quantities match:
        var allSameQty = variants.every(function(v) {
          return Number(v.quantity) === Number(variants[0].quantity);
        });
        if (allSameQty) {
          bundleQty = Number(variants[0].quantity) || 0;
        } else {
          // If not equal, still show an average-ish bundle value.
          // You could also do: bundleQty = "-";
          bundleQty = Math.floor(totalQty / groupSize);
        }

        $groupQtyDom.find(".custom-cart-item__variant-title").html("Quantity");
        $groupQtyDom.find("input").val(bundleQty).prop("readonly", true);

        // Bind plus/minus to atomic update all
        self.bindGroupQtyButtons(
          $groupQtyDom.find(".custom-cart-item__qty-input-plus"),
          $groupQtyDom.find(".custom-cart-item__qty-input-minus"),
          variants
        );

        $qtyWrapper.append($groupQtyDom);
        return;
      }

      // Normal mode (1–2 variants): per-variant controls
      variants.forEach(function (variant) {
        var option = (variant.variant_options && variant.variant_options[0]) || "Default Title";

        var $qtyDom = $(self.selectors.qtyTemplate).clone();
        $qtyDom.removeAttr("id").show();

        $qtyDom.addClass("custom-cart-item__qty-" + String(option).toLowerCase());
        $qtyDom.attr("data-cart-item-key", variant.key);

        $qtyDom.find("input").val(variant.quantity);
        $qtyDom
          .find(".custom-cart-item__variant-title")
          .html("Quantity " + (option !== "Default Title" ? option : ""));

        // +/- buttons update input then triggers change handler
        self.bindSingleQtyButtons($qtyDom.find(".custom-cart-item__qty-input-plus"), $qtyDom.find(".custom-cart-item__qty-input-minus"));

        // On input change -> update single line item
        $qtyDom
          .find("input")
          .off("change.cart")
          .on(
            "change.cart",
            debounce(function () {
              self.updateQuantity(variant.key, $qtyDom.find("input").val());
            }, 250)
          );

        $qtyWrapper.append($qtyDom);
      });
    },

    bindSingleQtyButtons: function ($plus, $minus) {
      $minus.off("click.cart").on("click.cart", function () {
        var $input = $(this).parent().find("input");
        var count = parseInt($input.val(), 10) - 1;
        count = count < 0 ? 0 : count;
        $input.val(count).trigger("change");
        return false;
      });

      $plus.off("click.cart").on("click.cart", function () {
        var $input = $(this).parent().find("input");
        $input.val(parseInt($input.val(), 10) + 1).trigger("change");
        return false;
      });
    },

    bindGroupQtyButtons: function ($plus, $minus, variants) {
      var self = this;

      $minus.off("click.cart").on("click.cart", function () {
        self.updateGroupQuantityAtomic(variants, -1);
        return false;
      });

      $plus.off("click.cart").on("click.cart", function () {
        self.updateGroupQuantityAtomic(variants, +1);
        return false;
      });
    },

    // ----------------------------
    // ATOMIC group update:
    // - Pre-check master variant inventory (when tracked + deny) using /variants/{id}.js
    // - Apply updates to ALL variants using /cart/update.js
    // - Post-check applied quantities; if mismatch => rollback to previous quantities
    // - Refresh from /cart.js
    // ----------------------------
    updateGroupQuantityAtomic: async function (variants, delta) {
      var self = this;
      variants = variants || [];
      if (!variants.length) return;

      // Identify master (properties.master == "1"), fallback to first
      var master = variants.find(function (v) {
        return v && v.properties && String(v.properties.master) === "1";
      }) || variants[0];

      // Snapshot previous quantities for rollback
      var prev = { updates: {} };
      variants.forEach(function (v) {
        prev.updates[v.key] = Number(v.quantity) || 0;
      });

      // Desired quantities
      var desired = { updates: {} };
      variants.forEach(function (v) {
        var currentQty = Number(v.quantity) || 0;
        desired.updates[v.key] = Math.max(0, currentQty + delta);
      });

      // If increasing, pre-check master inventory (only if inventory tracked + deny)
      if (delta > 0) {
        var masterVariantId = self._getVariantIdFromLineItem(master);
        var canInc = await self._canIncreaseMaster(masterVariantId, Number(master.quantity) || 0, delta);
        if (!canInc) {
          // Replace with your snackbar if you want
          alert("Not enough stock to increase this bundle.");
          return;
        }
      }

      self.showLoading(true);

      try {
        // Apply
        var state = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(desired),
        }).then(function (res) {
          return res.json();
        });

        // Post-check: ensure all desired quantities were applied
        var mismatch = false;
        Object.keys(desired.updates).forEach(function (key) {
          var li = self._findLineItemByKey(state, key);
          var appliedQty = li ? Number(li.quantity) : 0;
          if (appliedQty !== Number(desired.updates[key])) mismatch = true;
        });

        if (mismatch) {
          // Rollback
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(prev),
          }).then(function (res) {
            return res.json();
          });

          alert("Could not update bundle due to stock limits. No changes were applied.");
        }

        // Refresh from cart.js so UI is always correct
        var latest = await fetch("/cart.js").then(function (r) {
          return r.json();
        });
        self.updateCartItems(latest);
      } catch (e) {
        console.log(e);
      } finally {
        self.showLoading(false);
      }
    },

    _getVariantIdFromLineItem: function (lineItem) {
      // Shopify cart line item commonly provides:
      // - id (variant_id)
      // - variant_id
      // We'll try both.
      if (!lineItem) return null;
      return lineItem.variant_id || lineItem.id || null;
    },

    _getVariantInfo: function (variantId) {
      var self = this;
      if (!variantId) return Promise.resolve(null);

      if (self._variantCache[variantId]) return Promise.resolve(self._variantCache[variantId]);

      return fetch("/variants/" + variantId + ".js", { method: "GET" })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          self._variantCache[variantId] = data;
          return data;
        })
        .catch(function () {
          return null;
        });
    },

    _canIncreaseMaster: async function (masterVariantId, currentQty, delta) {
      if (delta <= 0) return true;

      var v = await this._getVariantInfo(masterVariantId);

      // If we can't fetch variant info, don't block here (post-check + rollback handles it)
      if (!v) return true;

      // If inventory isn't tracked, don't block
      if (!v.inventory_management) return true;

      // If overselling allowed, don't block
      if (v.inventory_policy === "continue") return true;

      // If Shopify doesn't expose inventory_quantity, fall back to "available"
      // This only blocks when there's zero stock.
      if (typeof v.inventory_quantity === "undefined") {
        return v.available !== false;
      }

      var requested = (Number(currentQty) || 0) + delta;
      return requested <= (Number(v.inventory_quantity) || 0);
    },

    _findLineItemByKey: function (cartState, key) {
      if (!cartState || !cartState.items) return null;
      for (var i = 0; i < cartState.items.length; i++) {
        if (cartState.items[i].key === key) return cartState.items[i];
      }
      return null;
    },

    // ----------------------------
    // Sidebar items
    // ----------------------------
    createSideBarCartItems: function () {
      var self = this;
      var $wrapper = $(self.selectors.sidebarWrapper);
      $wrapper.html("");

      var items = (window.cartSort && window.cartSort.sortedCartItems) || [];
      if (!items.length) return;

      for (var i = items.length - 1; i >= 0; i--) {
        (function renderSidebarItem(cartItem) {
          var $dom = $(self.selectors.sidebarItemTemplate).clone();
          $dom.removeAttr("id").show();

          $dom.find(".sidebar-cart-item__product").attr("href", cartItem.url || "#");
          $dom.find(".sidebar-cart-item__title").html(cartItem.product_title || "");
          $dom.find(".sidebar-cart-item__image").attr(
            "src",
            cartItem.featured_image && cartItem.featured_image.url ? cartItem.featured_image.url : ""
          );
          $dom.find(".sidebar-cart-item__final-price").html(window.helper._convertMoney(cartItem.final_line_price));

          if (cartItem.variants && cartItem.variants[0] && cartItem.variants[0].selling_plan_allocation) {
            $dom
              .find(".sidebar-cart-item__subscription-text")
              .html(cartItem.variants[0].selling_plan_allocation.selling_plan.name);
          } else {
            $dom.find(".sidebar-cart-item__subscription-text").hide();
          }

          // QTY text
          var qtyText = "QTY: ";
          (cartItem.variants || []).forEach(function (variant, idx) {
            var option = (variant.variant_options && variant.variant_options[0]) || "Default Title";
            var label = option !== "Default Title" ? option : "";
            qtyText += label + ": " + variant.quantity;
            if (idx !== cartItem.variants.length - 1) qtyText += " | ";
          });

          $dom.find(".sidebar-cart-item__qty-text").html(qtyText);

          $dom.appendTo($wrapper);

          $(".sidebar-cart-items-wrapper__active").show();
          $(".sidebar-cart-items-wrapper__inactive").hide();
        })(items[i]);
      }

      self.updateTotalPrice(window.cartSort.cartItems);
      self.updateCartCountBubble(window.cartSort.cartItems);
    },

    // ----------------------------
    // Update quantity (single line)
    // ----------------------------
    updateQuantity: function (id, value) {
      var self = this;

      var formData = {
        id: id,
        quantity: value,
      };

      self.showLoading(true);

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (state) {
          self.updateCartItems(state);
          self.showLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          self.showLoading(false);
        });
    },

    // ----------------------------
    // Remove whole group (set all keys to 0)
    // ----------------------------
    removeCartItemGroup: function ($itemDom, cartItem) {
      var self = this;
      var payload = { updates: {} };

      (cartItem.variants || []).forEach(function (v) {
        payload.updates[v.key] = 0;
      });

      self.showLoading(true);

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (state) {
          self.updateCartItems(state);
          self.showLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          self.showLoading(false);
        });
    },

    // ----------------------------
    // Refresh UI after cart change
    // ----------------------------
    updateCartItems: function (state) {
      window.cartSort.init(state);
    },

    // ----------------------------
    // Totals + count bubble
    // ----------------------------
    updateTotalPrice: function (state) {
      $(this.selectors.subtotalEls).html(window.helper._convertMoney(state.total_price));
    },

    updateCartCountBubble: function (cart) {
      var $bubble = $(this.selectors.cartCountBubble);

      if ($bubble.length < 1) {
        var $countBubble =
          $(
            '<div class="cart-count-bubble">' +
              '<span aria-hidden="true">0</span>' +
              '<span class="visually-hidden">0 items</span>' +
              "</div>"
          );
        $countBubble.find("span:first-child").html(cart.item_count);
        $countBubble.find("span:last-child").html(cart.item_count + " items");
        $(this.selectors.cartIcon).append($countBubble);
      } else {
        $bubble.find("span:first-child").html(cart.item_count);
        $bubble.find("span:last-child").html(cart.item_count + " items");
      }
    },

    // ----------------------------
    // Prescription modal (kept same)
    // ----------------------------
    showPrescriptionDetails: function (products) {
      for (var p = 0; p < products.length; p++) {
        var opt = products[p].variant_options[0].toLowerCase();
        var optionProperties = $(
          '<ul class="prescription-properties-list prescription-properties-list__' +
            opt +
            '">' +
            '<li class="prescription-properties-lsit-item-title">' +
            products[p].variant_options[0] +
            " Eye</li>" +
            '<li class="prescription-properties-lsit-item power">' +
            products[p].properties.Power +
            "</li>" +
            '<li class="prescription-properties-lsit-item power">' +
            products[p].properties["Base Curve"] +
            "</li>" +
            '<li class="prescription-properties-lsit-item power">' +
            products[p].properties.Diameter +
            "</li>" +
            '<li class="prescription-properties-lsit-item power">' +
            products[p].properties["Add Power"] +
            "</li>" +
            "</ul>"
        );

        if (products[p].properties["Add Power"] === undefined) {
          $(".prescription-properties-list__option-labels li:nth-child(4)").hide();
          optionProperties.find("li:nth-child(5)").hide();
        }

        $(".prescription-info__product-title").html(products[p].product_title);
        optionProperties.appendTo(".prescription-info-grid");
      }

      window.prescriptionModal._show();
    },

    

    // ----------------------------
    // Glasses Prescription modal
    // ----------------------------
    showGlassesPrescriptionDetails: function (products) {

      $(".glasses-prescription-info").html(' ')

      for (var p = 0; p < products.length; p++) {
        console.log(products[p].properties, products[p].properties['master'])
        if(products[p].properties['master'] != undefined) {
          var item = products[p]
          let block = $(`<div>
            <h4>${item.title}</h4>
            <ul>
            </ul>
            </div>`)

          $.each(item.properties, function(i, d) {
            if(d != "Left: , Right: " && d != "" && i != 'properties_id' && i != 'glasses_prescription' && i != 'master') {
              const blockItem = $(`<li><span>${i}</span> : <span>${d}</span></li>`)
              blockItem.appendTo(block.find('ul'));
            }
          })

          $(".glasses-prescription-info__product-title").html(products[p].product_title);
          block.appendTo(".glasses-prescription-info");
        }
      }

      window.glassesPrescriptionModal._show();
    },

    // ----------------------------
    // Empty state
    // ----------------------------
    empty: function () {
      $(".sidebar-cart-items-wrapper__active").hide();
      $(".sidebar-cart-items-wrapper__inactive").show();

      $("#main-cart-footer, .cart__contents").html(" ");
      $(".cart__contents").hide();
      $(".cart__main-title-wrapper").hide();
      $(".cart__warnings, .cart__empty-text").show();
    },

    showLoading: function (show) {
      if (show) $(this.selectors.loading).fadeIn();
      else $(this.selectors.loading).fadeOut();
    },
  });

  // ----------------------------
  // debounce fallback (in case not defined)
  // ----------------------------
  function debounce(fn, delay) {
    if (window.debounce) return window.debounce(fn, delay);
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, delay || 250);
    };
  }
})();
